import * as React from "react";
import { connect } from "react-redux";
import IProps from "./IProps";

import "../../../assets/sass/widgets/customAddButton.scss";
import { handleEnter, imagePathurl, getSessionValue } from "../../utils/utils";
import { IS_EDITABLE_WARRANTY } from "../../constants/storageKeys";
import * as CONFIG from "../../../config.json";
/**
 * @class CustomAddButton
 * @description This component acts a button with dynamic icon serving dynamic functionalities.
 * @category Widgets
 */
class CustomAddButton extends React.Component<IProps, null> {
    toggleContent = (value: string) => {
        this.props.onChange(value);
    };
    scrollToElement = (id) => {
        const elmn = document.getElementById(id);
        if (elmn) {
            elmn.scrollIntoView(true);
            const scrolledY = window.scrollY;
            if (scrolledY) {
                window.scroll(0, scrolledY - 150);
            }
        }
    };
    addContainer = (option: any) => {
        if (getSessionValue(IS_EDITABLE_WARRANTY)){
            return;
        }
        this.toggleContent(option.enum[0]);
        setTimeout(() => {
            this.scrollToElement(`${option.title.replace(/ +/g, "")}_delete_icon`);
        }, 100);
    };
    /**
     * Construct image path - either external / internal
     * @param {string} imgSrc
     * @return {string} image path
     */
    getImagePath = (imgSrc: string): string => {
        const getimagePath = imagePathurl();
        const imgPath = imgSrc.includes("Src") ? imgSrc.replace("Src", `${CONFIG["accessoriesImagePath"]}`) : imgSrc;
        return imgSrc.includes("http") ? imgPath : `${getimagePath}${imgPath}`;
    };

    componentDidMount() {
        if (!this.props.value) {
            this.props.onChange(this.props.schema.default);
        }
        if (this.props.errorDetails[`root_${this.props.schema.const.id}`]) {
            const element = document.getElementById(`root_${this.props.schema.const.id}`);
            if (element && element.getElementsByTagName("span").length > 0) {
                element.getElementsByTagName("span")[0].click();
            }
        }
    }

    componentDidUpdate(prevProps: any, prevState: any) {
        const { value: prevValue, schema: prevSchema } = prevProps;
        const { value, schema, onChange } = this.props;
        const tempArr = schema.anyOf.filter((item) => item.enum[0] === value);
        if (typeof value !== "string") {
            onChange(schema.default || "");
            return;
        }
        if (prevValue !== value) {
            // triggered onchange of a radio button
            onChange(value);
        } else if (tempArr.length > 0 && tempArr[0].enum[0] === value) {
            // called upon if there is a new schema which has a previous selectionn within already
            onChange(value);
        } else if (
            // called when there is a new schema list
            prevSchema.anyOf.length !== schema.anyOf.length ||
            !prevSchema.anyOf.every((item) => schema.anyOf.some((elem) => elem.title === item.title))
            // prevSchema.anyOf.every((x) => !schema.anyOf.includes(x))
        ) {
            setTimeout(function () {
                schema.default ? onChange(schema.default) : onChange("");
            }, 1);
        }
    }
    onOptionClick = (index, option) => {
        return index === 0 ? this.toggleContent(option.enum[0]) : this.addContainer(option);
    };
    render() {
        const { id, value, schema, isSolarCertified } = this.props;
        let displayNone = false;
        if (schema.const.checkSolarCertified && !isSolarCertified) {
            displayNone = true;
        }
        if (!isSolarCertified && schema.const.label === "Solar") {
            displayNone = true;
        }
        if (schema.const.ishidden){
            displayNone = true;
        }
        return (
            <div className={`content ${value === "SHOW" || displayNone ? "d-none" : ""}`}>
                {schema.anyOf.map((option, index) => (
                    <div
                        id={schema.const.id}
                        key={`${id}-${index}`}
                        className={`${index === 0 ? "d-none" : "custom-btn"}`}
                        onClick={() => this.onOptionClick(index, option)}
                    >
                        {index !== 0 && (
                            <React.Fragment>
                                <div id={`root_${schema.const.id}`}>
                                    <span
                                        id={`${option.title.replace(/ +/g, "")}_add_icon`}
                                        className="add-icon"
                                        tabIndex={schema.const.tabIndex}
                                        onClick={() => this.addContainer(option)}
                                        onKeyPress={handleEnter}
                                    />
                                </div>
                                <img src={this.getImagePath(schema.const.imgsrc)} alt={option.title} />
                                <div className="btn-title">{option.title}</div>
                            </React.Fragment>
                        )}
                    </div>
                ))}
            </div>
        );
    }
}
export function mapStateToProps(state): any {
    const contractorSettings = state.dynamicFormInfo.contractorSettings || {};
    return {
        errorDetails: state.dynamicFormInfo.errorDetails || {},
        isSolarCertified: contractorSettings.isSolarCertified || false,
    };
}
export function mapDispatchToProps(dispatch): any {
    return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomAddButton);
